import { PageWrapper } from "@/components";
import SpinLoader from "@/containers/Layout/MainLayout/SpinLoader";
import {
  ImagesCard,
  MilestoneCard,
  MobileTabsLayout,
  ProjectDetailsCard,
  ProjectHeader,
  ProjectLeadersForm,
  SkuCard,
} from "@/containers/Project/components";
import { CONTENT_WIDTH, PROJECT_STATUS, ProjectUserPermissions } from "@/enums";
import { ProjectHeaderElements } from "@/enums/ProjectHeaderElements";
import { routes } from "@/helpers";
import { useMobileLayout } from "@/hooks/useAppMedia";
import { useProjectContext } from "@/providers";
import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

const Project = () => {
  const intl = useIntl();
  const [showDetails, setShowDetails] = useState(false);
  const isMobileLayout = useMobileLayout();
  const [activeMobileTab, setActiveMobileTab] = useState("1");
  const {
    canUser,
    projectLoading: isLoading,
    project,
    setProject,
  } = useProjectContext();

  const handleShowDetails = () => {
    setShowDetails((prev) => !prev);
  };

  const [inactiveHeaderElements, setInactiveHeaderElements] = useState([]);

  useEffect(() => {
    if (!project?.status) return;

    const elements = [];

    if (project.status === PROJECT_STATUS.intake.draft.id) {
      elements.push(
        ProjectHeaderElements.TEAMS,
        ProjectHeaderElements.KPIS,
        ProjectHeaderElements.CTQ
      );
    } else if (project.status === PROJECT_STATUS.intake.inApproval.id) {
      elements.push(ProjectHeaderElements.KPIS);
    }

    if (project.isCtqDisabled && !elements.includes(ProjectHeaderElements.CTQ)) {
      elements.push(ProjectHeaderElements.CTQ);
    }

    setInactiveHeaderElements(elements);
  }, [project?.status, project?.isCtqDisabled]);

  const pageTitle = () => {
    if (project?.projectNumber && project?.projectName) {
      return intl.formatMessage(
        { id: "project.tabTitle" },
        { id: project?.projectNumber, name: project?.projectName }
      );
    }
    return intl.formatMessage({ id: "project.title" });
  };

  if (isLoading) return <SpinLoader />;

  return (
    <>
      <PageWrapper
        pageTitle={pageTitle()}
        backButtonRoute={routes.projects.list}
      >
        <Row flex={1} gutter={[16, 48]} className="pb-2">
          <Col flex={1}>
            <ProjectHeader
              showDetails={showDetails}
              handleShowDetails={handleShowDetails}
              mobile={isMobileLayout}
              source={"project"}
              expandButtonText={intl.formatMessage({
                id: "project.intake",
              })}
              inActiveElements={inactiveHeaderElements}
            />
            <ProjectDetailsCard open={showDetails} />
          </Col>
        </Row>
        {isMobileLayout && (
          <MobileTabsLayout
            milestonesCard={<MilestoneCard />}
            projectLeadersCard={<ProjectLeadersForm />}
            imagesCard={<ImagesCard />}
            skuCard={
              <SkuCard
                readOnly={!canUser(ProjectUserPermissions.EditProjectSkus)}
                skuData={project?.stockKeepingUnits}
                setProject={setProject}
              />
            }
            onTabChange={setActiveMobileTab}
            activeTab={activeMobileTab}
          />
        )}
        {!isMobileLayout && (
          <Row gutter={[16, 48]} className="pb-2">
            <Col span={CONTENT_WIDTH.fiveSixths}>
              <MilestoneCard />
            </Col>
            <Col span={CONTENT_WIDTH.oneSixth}>
              <Row gutter={[16, 48]} className="pb-2">
                <Col flex={1}>
                  <ProjectLeadersForm />
                </Col>
              </Row>
              <Row gutter={[16, 48]} className="pb-2">
                <Col flex={1}>
                  <ImagesCard />
                </Col>
              </Row>
              <Row gutter={[16, 48]} className="pb-2">
                <Col flex={1}>
                  <SkuCard
                    readOnly={!canUser(ProjectUserPermissions.EditProjectSkus)}
                    skuData={project?.stockKeepingUnits}
                    setProject={setProject}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </PageWrapper>
    </>
  );
};

export default Project;
